var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"chat-scroll",rawName:"v-chat-scroll"}],staticClass:"messages d-flex flex-column"},_vm._l((_vm.messages),function(message){return _c('message',{key:message.id,attrs:{"message":message}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d2a236","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageList.vue
// module id = 6YnN
// module chunks = 1